import dayjs from 'dayjs';
import Helpers from '@Apis/helpers';
import constants, { QUANTITY, toISTDate, DEFAULT_CUR_ROUND_OFF, INFINITE_EXPIRY_DATE } from '@Apis/constants';
import HideValue from '../../../Common/RestrictedAccess/HideValue';

const ListScreenKeys = ({ documentData, MONEY, priceMasking }) => {
  const record = documentData;
  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const selectedUsers = record?.assignees?.map((assignee) => ({
    userId: assignee?.user_id,
    title: assignee?.first_name,
    identity: assignee?.identity,
  })) || [];

  return [
    {
      label: 'QC #',
      value: record?.qc_number,
    },
    {
      label: 'LOCATION',
      value: `${record?.entity_info?.tenant_name} (${record?.entity_info?.department || ''})`,
    },
    {
      label: 'PRODUCT',
      value: `#${record?.entity_info?.internal_sku_code}`,
    },
    {
      label: 'QUALITY RULE',
      value: record?.quality_control_rules?.quality_control_name
    },
    {
      label: 'Assignees',
      value: selectedUsers?.map((assignee) => (
        `${assignee?.title}, `
      )),
    },
    {
      label: 'BATCH QTY',
      value: record?.original_qty ? `${Number(record?.original_qty) + Number(record?.sample_quantity)} ${record?.entity_info?.uom_info?.uqc?.toProperCase() || ''}` : '-',
    },
    {
      label: 'SAMPLE QTY',
      value: record?.sample_quantity ? `${Number(record?.sample_quantity)} ${record?.entity_info?.uom_info?.uqc?.toProperCase() || ''}` : '-',
    },
    {
      label: 'APPROVED QTY',
      value: record?.approved_qty ? `${Number(record?.approved_qty)} ${record?.entity_info?.uom_info?.uqc?.toProperCase() || ''}` : '-',
    },
    {
      label: 'REJECTED QTY',
      value: record?.rejected_qty ? `${Number(record?.rejected_qty)} ${record?.entity_info?.uom_info?.uqc?.toProperCase() || ''}` : '-',
    },
    {
      label: 'BATCH EXPIRY',
      value: record?.expiry_date === INFINITE_EXPIRY_DATE ? '-' : dayjs(record?.expiry_date).format('DD/MM/YYYY'),
    },
    {
      label: 'BATCH COST PRICE',
      value: record?.entity_info?.cost_price ? ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view batch cost price" /> : MONEY(record?.entity_info?.cost_price)) : '-',
    },
    {
      label: 'CREATED DATE',
      value: toISTDate(record?.created_at).format('DD/MM/YYYY'),
    },
    {
      label: 'COMPLETION DATE',
      value: record?.approved_at ? toISTDate(record?.approved_at).format('DD/MM/YYYY hh:mm A') : '-',
    },
  ];

};

export default ListScreenKeys;